//be47462tn/VDSBcSPTTrdJz68z
// Bearer: ODc5YjcxMzFkOThiYTlhOGY0NzE2ODg1YzkzYTIxZTNkZmVlNzllM2VlYjU1YWM4YzVhNzYzODBjYTRkOGUxYg==
const config = {
  s3: {
    REGION: "ap-northeast-1",
    BUCKET: "tutors-app-upload",
  },
  apiGateway: { // stage: prod
    REGION: "ap-northeast-1",
    URL: "https://k3j0amewmj.execute-api.ap-northeast-1.amazonaws.com",
  },
//  apiGateway: { // stage: stg
//    REGION: "ap-northeast-1",
//    URL: "https://cv207mi090.execute-api.ap-northeast-1.amazonaws.com",
//  },
//  apiGateway: {
//    REGION: "ap-northeast-1",
//    URL: "https://fhe8i5wafh.execute-api.ap-northeast-1.amazonaws.com",
//  },
  cognito: {
    REGION: "ap-northeast-1",
    USER_POOL_ID: "ap-northeast-1_m6CMQ8Tri",
    APP_CLIENT_ID: "kij7elpg3pc1045qhtt7lociu",
    IDENTITY_POOL_ID: "ap-northeast-1:12ea4ffd-a007-43db-9582-e9284a6543eb",
  },
  mail: {
    ak: 'q34MVF9Dtxtvcj01hTSIxPp3RPCuhAfRMm1w7VZ81HrvPMUP6y6SHLK1KT6VWk7v',
    acceptMailSubject: "登録承認のお知らせ",
    welcomeMailSubject: "登録受付のお知らせ",
    invitationMailSubject: "会員専用ページログインのご案内（{{mTypeName}}）【日本臨床スポーツ医学会】",
    registeredMailSubject: "への入会申込み受領【日本臨床スポーツ医学会】",
    source: "no-reply@rinspo.info",
    bcc: "apply@rinspo.jp",
    invitationBody: `/*

==============================================================
このメールアドレスは送信専用です。
お問い合わせの際は、日本臨床スポーツ医学会 事務局までご連絡ください。
==============================================================

{{name}} 様

日本臨床スポーツ医学会　会員専用サイトのご案内です。
マイページをご利用いただくにあたりまして、
下記のリンクをクリックしてパスワードを設定してください。
{{url}}

-----------------------------------------------------------------------------------------
日本臨床スポーツ医学会　事務局
〒104-0041　東京都中央区2-4-14 新富田所ビル4階
一般社団法人 会議支援センター内
TEL：03-6222-9874　FAX：03-6222-9875　E-mail：rnsp@rinspo.jp

    */
`.trim(),
    registeredBody: `/*

==============================================================
このメールアドレスは送信専用です。
お問い合わせの際は、日本臨床スポーツ医学会 事務局までご連絡ください。
==============================================================

{{name}} 様
{{}}
日本臨床スポーツ医学会　{{memLabel}}入会申込みを受け付けました。
{{greetingNotice}}
恐れ入りますが、今しばらくお待ちくださいませ。

ご不明な点やご質問等ございましたら、以下事務局にお問い合わせください。

-----------------------------------------------------------------------------------------
日本臨床スポーツ医学会　事務局
〒104-0041　東京都中央区新富2-4-14 新富田所ビル4階
一般社団法人 会議支援センター内
TEL：03-6222-9874　FAX：03-6222-9875　E-mail：rnsp@rinspo.jp

   */
`.trim()
  },
  awssdk: {
    REGION: "ap-northeast-1",
    accessKeyId: "AKIAS7ECN2RJTTOHBCMW",
    secretAccessKey: "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",
    USER_POOL_ID: "ap-northeast-1_m6CMQ8Tri",
    APP_CLIENT_ID: "kij7elpg3pc1045qhtt7lociu",
    IDENTITY_POOL_ID: "ap-northeast-1:12ea4ffd-a007-43db-9582-e9284a6543eb",
  },
  url: "https://www.rinspo.info"
};

export default config;
